import Action from "../actions";

export function setRecaptchaAction(recaptchaValue) {
    return {
        type: Action.SET_GG_RECAPTCHA_VALUE,
        recaptchaValue
    }
}
